import styled from 'styled-components';
import { Form } from 'antd';

export const GenericFormItemStyle = styled(Form.Item)``;
